import axios from "axios";
import { toast } from "react-toastify";
export const GetAllSubmittedVouchers = (data) => {
  return {
    type: "get_submittedVouch",
    payload: data,
    loader: false,
  };
};
export function getSubmittedVouchers(data) {
  return (dispatch) => {
    axios({
      url: `${
        process.env.REACT_APP_API_URL
      }Vouchers/Submitted/GetAll?projectId=${localStorage.getItem(
        "ProjectId"
      )}&From=${data.From ? data.From : ""}&To=${data.To ? data.To : ""}`,
      method: "Get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetAllSubmittedVouchers(result.data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
